/* istanbul ignore file */
import { SvgIcon, SvgIconProps } from '@mui/material';

export const BankIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 16 16">
            <rect width="16" height="16" rx="3" fill="#606060" />
            <g clipPath="url(#clip0_2690_292)">
                <path
                    d="M8.90646 4.75894C8.90693 4.24736 7.86378 3.83301 6.57847 3.83301C5.29315 3.83301 4.25093 4.24783 4.25 4.75894M4.25 4.75894C4.25 5.27052 5.29222 5.68488 6.57847 5.68488C7.86471 5.68488 8.90693 5.27052 8.90693 4.75894L8.90693 8.35154M4.25 4.75894V10.3145C4.25047 10.8261 5.29269 11.2405 6.57847 11.2405C7.20203 11.2405 7.76505 11.1418 8.18278 10.9831M4.25047 6.61081C4.25047 7.12239 5.29269 7.53674 6.57893 7.53674C7.86518 7.53674 8.9074 7.12239 8.9074 6.61081M8.21072 9.12243C7.79067 9.28679 7.2146 9.38864 6.57847 9.38864C5.29269 9.38864 4.25047 8.97428 4.25047 8.4627M11.553 8.60994C12.3712 9.42337 12.3712 10.7428 11.553 11.5563C10.7348 12.3697 9.40755 12.3697 8.58933 11.5563C7.77111 10.7428 7.77111 9.42337 8.58933 8.60994C9.40755 7.7965 10.7348 7.7965 11.553 8.60994Z"
                    stroke="#F5FAFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2690_292">
                    <rect
                        x="3"
                        y="3"
                        width="10"
                        height="10"
                        rx="2"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};
